import React, {useState, useEffect} from 'react'
import Spinner from 'components/common/Spinner'
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';


// reactstrap components
import {
  Button,
  Card,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";


import {getCalculateFiled, getSingleFile, postCalculateFiled} from "actions/uploadFile";

const CalculateFileTable = ({UploadFile : {fileCalculation,  loading, error, importLoading}, getCalculateFiled, getSingleFile, postCalculateFiled}) => {
    const [modalConfig, setModalConfig] = useState({
        isShow: false,
        fileID: null,
        getChecker: null
    })

    const [created, setCreated] = useState(true)
    useEffect(() => {
      if(!importLoading&&!created){ //calc finished and not on mounted
        if(error == null){
          toast.info('Dane zostały przesłane do rozliczenia', { position: "bottom-right" })
        }else{
          toast.error('Wystąpił problem z rozliczaniem kosztów!', { position: "bottom-right" })
        }
      }
      getCalculateFiled()
      setCreated(false)
    }, [importLoading])

    const prepareFieldCalculation = async (e, fileID) => {
      e.preventDefault();
      const pcfResponse = await postCalculateFiled(fileID);
      console.log('calculate field response', pcfResponse);
      pollTaskStatus(fileID);
    }

    const pollTaskStatus = async (fileID, retries = 100) => {
      if (retries <= 0) return;
  
      try {
        const gsfResponse = await getSingleFile(fileID);
        console.log('single file response', gsfResponse);
        // only proc again if the initial request returned a valid response
        if (gsfResponse?.data?.id) {
          const auxID = gsfResponse.data.id;
          if (gsfResponse.data.was_calculated === false) {
            setTimeout(() => pollTaskStatus(auxID, retries - 1), 3000);
          }
        }
      } catch (err) {
          console.error("Error polling task status:", err);
      }
  };

    return (
        <>
         <ToastContainer />
         <Row>
            <Col className="ml-auto mr-auto" md="11">
              
              {loading || importLoading 
              ? (<div className="text-center" style={{margin: '20px 0px'}}>
                <span>
                  <Spinner/><br/>
                  {importLoading?
                    <>Dane zostały przesłane na serwer i są przeliczane.<br/>Proszę czekać...</>:
                    <>Wczytywanie danych, proszę czekać...</>
                  }
                  </span>
              </div>)
            : (<>
              <h2 className="h4 title">
                <small>Lista plików do rozliczenia</small>
              </h2>
              <Table striped>
                <thead className='smallerFont'>
                  <tr>
                    <th>Nazwa Pliku</th>
                    <th>Data Przesłania</th>
                    <th>Dane za okres</th>
                    <th className='text-center'>Wysłano do rozliczenia</th>
                    <th className='text-center'>Rozliczone</th>
                    <th className="text-right">Opcje</th>
                  </tr>
                </thead>
                <tbody>
                    {fileCalculation && fileCalculation.map((fileItem, idx) => {
                        return(
                            <tr key={fileItem.id}>

                    <td>{fileItem.file_calc.name}</td>
                    <td>{fileItem.file_calc.date.split('T')[0]}</td>
                    <td>{fileItem.month +" / "+ fileItem.year}</td>
                    <td className='text-center'>
                        {fileItem.sent_to_calculation? (
                            <i className="fas fa-check"></i>
                        ) : (
                            <i className="fas fa-times"></i>
                        )}
                    </td>
                    <td className='text-center'>
                      {fileItem.is_being_calculated?<>
                        <i className="fas fa-spinner fa-spin" id={"tooltip-wait"+idx}></i>
                        <UncontrolledTooltip
                          delay={0}
                          placement="top"
                          target={"tooltip-wait"+idx}
                        >
                          Trwa rozliczanie, proszę czekać
                        </UncontrolledTooltip>
                      </>:<>
                        {fileItem.was_calculated ? 
                          <i className="fas fa-check"></i> : <i className="fas fa-times"></i>
                        }
                      </>}
                    </td>
                    {/* actions */}
                    <td className="td-actions text-right">
                      <Button
                        className="btn-link mr-1"
                        color="info"
                        data-toggle="tooltip"
                        // id="tooltip542628903"
                        id={"tooltip-Dane"+idx}
                        onClick={(e)=>{prepareFieldCalculation(e, fileItem.id)}}
                        size="sm"
                        type="button"
                        disabled={fileItem.is_being_calculated}
                        aria-label='Wyślij do przeliczenia'
                      >
                        <i className="fas fa-upload"></i>
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        placement="top"
                        // target="tooltip542628903"
                        target={"tooltip-Dane"+idx}
                      >
                        Wyślij do przeliczenia
                      </UncontrolledTooltip>
                      
                    </td>

                    </tr>
                        )
                    })}
                </tbody>
              </Table> 
              </>)}
              
            </Col>
          </Row>

        </>
    )
}

const mapStateToProps = (state) => ({
  UploadFile: state.UploadFile,
});

export default connect(mapStateToProps, {getCalculateFiled, getSingleFile, postCalculateFiled})(CalculateFileTable)
